
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'prediction/flight'
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.航空预报接口')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,}
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "batchNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.航空主单号陆运主单号')}`},
                {name: "flightNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.航班号')}`},
                {name: "flightDate",type: "String",require: "Y",normal: "yyyy-MM-dd HH:mm:ss",describe: `${this.$t('onlineDoc.航班日期')}`},
                {name: "flightExpectStartTime",type: "String",require: "Y",normal: "yyyy-MM-dd HH:mm:ss",describe: `${this.$t('onlineDoc.航班预计起飞时间')}`},
                {name: "flightExpectEndTime",type: "String",require: "Y",normal: "yyyy-MM-dd HH:mm:ss",describe: `${this.$t('onlineDoc.航班预计到达时间')}`},
                {name: "flightActualStartTime",type: "String",require: "N",normal: "yyyy-MM-dd HH:mm:ss",describe: `${this.$t('onlineDoc.航班实际起飞时间')}`},
                {name: "flightActualEndTime",type: "String",require: "N",normal: "yyyy-MM-dd HH:mm:ss",describe: `${this.$t('onlineDoc.航班实际到达时间')}`},
                {name: "shippingWeight",type: "Double",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运送重量')}`},
                {name: "originationCountry",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.起始地国家')}`},
                {name: "destinationCountry",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.目的地国家')}`},
                {name: "originationAirport",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.起始地机场')}`},
                {name: "destinationAirport",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.目的地机场')}`},
                {name: "destinationPort",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.目的港')}`}
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                  ]
            }

        ],
        //请求示例
        requestCode: `Header：
          apiAccount=292508153084379141
          digest=bIN6a2l07XweEKRizSHS9g==
          timestamp=1645775620879
          Body：
          bizContent="{'batchNo': '086024131', 'flightNo':'12321312', 'originationCountry': 'CHINA', 'shippingWeight': 23.22,'flightDate':'2022-07-19 10:59:04','flightExpectStartTime':'2022-07-19 10:59:04','flightExpectEndTime':'2022-07-19 10:59:04','flightActualStartTime':'2022-07-19 10:59:04','flightActualEndTime':'2022-07-19 10:59:04', 'originationCountry': 'CHINA', 'destinationCountry': 'CHINA', 'originationAirport': 'CHINA', 'destinationAirport': 'CHINA', 'destinationPort': 'CHINA'}"`,
        //返回示例
        responseCode: JSON.parse(`{
            "code": "1",
            "msg": "success"
        }
        `),

      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{'batchNo': '086024131', 'flightNo':'12321312', 'originationCountry': 'CHINA', 'shippingWeight': 23.22,'flightDate':'2022-07-19 10:59:04','flightExpectStartTime':'2022-07-19 10:59:04','flightExpectEndTime':'2022-07-19 10:59:04','flightActualStartTime':'2022-07-19 10:59:04','flightActualEndTime':'2022-07-19 10:59:04', 'originationCountry': 'CHINA', 'destinationCountry': 'CHINA', 'originationAirport': 'CHINA', 'destinationAirport': 'CHINA', 'destinationPort': 'CHINA'}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>